/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:17:40
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-08-29 10:32:05
 * @FilePath: \app-client-h5\src\pages\waterUseRecord\index.jsx
 */
import React, { Component } from 'react';
import { getWateruse } from "./services";

import './index.scss'
class WaterUseRecord extends Component {
    ref = React.createRef();
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            emptyIcon: require('../../assets/empty.png'),
            wateruseList: []
        }
    }

    componentWillUnmount() {

    }
    componentDidMount() {
        document.title = '房间用水记录';
        this.getWateruse()
    }
    getWateruse = () => {
        getWateruse().then((res) => {
            console.log(res, '/');
            if (res.code == '200') {
                this.setState({
                    wateruseList: res.data
                })
            }
        })
    }
    renderEmpty() {
        return (
            <div className="empty">
                <div>
                    <img className="emptyIcon" src={this.state.emptyIcon} />
                </div>
                <div className='text'>暂无数据</div>
            </div>
        )
    }
    render() {
        const { wateruseList } = this.state;
        return (
            <div className='use-container'>
                {wateruseList.length == 0 ?
                    this.renderEmpty()
                    :
                    wateruseList.map((item, index) => {
                        return (
                            <div className='recordItem'>
                                <div className='top-content'>
                                    <span className='text'>上报时间：</span>
                                    <span className='time'>{item.uploadTime==null?'--':item.uploadTime}</span>
                                </div>
                                <div className='bottom-content'>
                                    <span className='text'>区间用水量：</span>
                                    <span className='number'>{item.intervalWater}<span className='unit'>吨</span></span>
                                </div>
                            </div>
                        )
                    })
                    
                }
            </div>
        )
    }
}
export default WaterUseRecord;

